// extracted by mini-css-extract-plugin
export default {"root":"k8TjDMVDugehkhiy5uue","section":"c8OTrSx__c0ql8ZlDHV3"};